/**
 * TODO: Rewrite this component as object value form field, e.g.
 * ```
 * type EventFormatValue = {
 *   format: EventFormat.VIRTUAL,
 *   virtualLink: string,
 *   inPersonLocation: string,
 *   virtualMeeting: { type: 'zoom' | 'googleMeet', id: number }
 * }
 * ```
 *
 * @example
 * ```
 * <EventFormatInput onValueChange={(v: EventFormatValue) => {}}>
 *   <EventFormatInput.FormatSelector />
 *   <EventFormatInput.VirtualLocation />
 *   <EventFormatInput.InPersonLocation />
 * </EventFormatInput>
 * ```
 */

import React from 'react';
import { useFormContext } from 'react-hook-form';

import { EventFormat } from 'types/event.types';
import { cn } from '@epoch-ui/lib/utils';
import { ButtonGroupField, ButtonGroupFieldItem, InputField } from '@epoch-ui/components/Form';

import { EventVirtualLocationField } from './EventVirtualLocationField';

interface EventFormatFieldsSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  disabled?: boolean;
  eventId?: number;
  timezoneCode?: string;
}

const EventFormatFieldsSection: React.FC<EventFormatFieldsSectionProps> = ({
  disabled,
  eventId,
  className,
  timezoneCode,
  ...props
}) => {
  const formCtx = useFormContext();

  const eventFormat = formCtx.watch('format');

  return (
    <div {...props} className={cn('tw-flex tw-flex-col tw-gap-4', className)}>
      <ButtonGroupField
        name="format"
        label="Format"
        disabled={disabled}
        onValueChange={(newFormat) => {
          if (newFormat !== EventFormat.IN_PERSON && newFormat !== EventFormat.HYBRID) {
            formCtx.setValue('inPersonLocation', '');
          }
          if (newFormat !== EventFormat.VIRTUAL && newFormat !== EventFormat.HYBRID) {
            formCtx.setValue('virtualLink', '');
            formCtx.setValue('zoomMeetingId', undefined);
            formCtx.setValue('googleMeetingId', undefined);
          }
        }}
      >
        <ButtonGroupFieldItem value={EventFormat.VIRTUAL}>Virtual</ButtonGroupFieldItem>
        <ButtonGroupFieldItem value={EventFormat.IN_PERSON}>In-person</ButtonGroupFieldItem>
        <ButtonGroupFieldItem value={EventFormat.HYBRID}>Hybrid</ButtonGroupFieldItem>
      </ButtonGroupField>

      {(eventFormat === EventFormat.VIRTUAL || eventFormat === EventFormat.HYBRID) && (
        <EventVirtualLocationField
          name="virtualLink"
          disabled={disabled}
          eventId={eventId}
          timezoneCode={timezoneCode}
        />
      )}

      {(eventFormat === EventFormat.IN_PERSON || eventFormat === EventFormat.HYBRID) && (
        <InputField
          name="inPersonLocation"
          label={
            <>
              Place or address <span className="tw-text-gray-500">(optional)</span>
            </>
          }
          disabled={disabled}
          className="tw-mt-0"
        />
      )}
    </div>
  );
};

export { EventFormatFieldsSection };
